import { Fragment, useEffect } from 'react';
import { useRouter } from 'next/router';
import * as fbq from "./fbq";
import { jsx as _jsx } from "react/jsx-runtime";
var sendPageView = function sendPageView() {
  fbq.pageview();
};
var FacebookPixel = function FacebookPixel(_ref) {
  var children = _ref.children;
  var router = useRouter();
  useEffect(function () {
    // This pageview only trigger first time (it is important for Pixel to have real information)
    /**
     * We are using this boolean to don't send the track in the routeChangeComplete when the page is loaded for the first time.
     * There is an open issue where routeChangeComplete is call in the first load :(
     * https://github.com/vercel/next.js/issues/11639
     * routeChangeComplete should only be called after a route has changed, if it's called whne the page is loaded for the first time
     * the pageView track will be send two times :alert:
     */
    var isFirstLoad = true;
    sendPageView();
    router.events.on('routeChangeComplete', function () {
      if (!isFirstLoad) {
        sendPageView();
      }
      isFirstLoad = false;
    });
    return function () {
      router.events.off('routeChangeComplete', sendPageView);
    };
  }, [router.events]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: children
  });
};
export default FacebookPixel;